import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const closeShortTransferOrderRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/transfer-orders/:id/close-short',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/transfer-orders/:id/close-short' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const closeShortTransferOrderResponse: Json = {
    title: 'RESPONSE',
    json: {
        'id': 22,
        'number': '24',
        'status': 'Closed Short',
        'type': 'Ship',
        'fromLocationGroup': {
            'id': 1,
            'name': 'Main'
        },
        'toLocationGroup': {
            'id': 2,
            'name': 'NY'
        },
        'carrier': {
            'id': 4,
            'name': 'Fedex',
            'service': {
                'id': 8,
                'name': 'Ground'
            }
        },
        'shipFromAddress': {
            'name': 'Main Warehouse',
            'street': '100 Main St',
            'city': 'Salt Lake City',
            'state': 'UT',
            'postalCode': '84101',
            'country': 'UNITED STATES'
        },
        'shipToAddress': {
            'name': 'East Warehouse',
            'street': '200 East Blvd',
            'city': 'Denver',
            'state': 'CO',
            'postalCode': '80201',
            'country': 'UNITED STATES'
        },
        'note': 'Urgent transfer for Q2 rebalancing',
        'ownerIsFrom': true,
        'revisionNumber': 2,
        'lastModified': {
            'username': 'admin',
            'dateLastModified': '2026-06-25T16:27:57.000+00:00'
        },
        'dateCreated': '2026-05-15T21:17:24.000+00:00',
        'dateIssued': '2026-06-05T18:34:29.000+00:00',
        'dateScheduled': '2025-12-29T01:44:45.000+00:00',
        'dateCompleted': '2026-06-26T14:12:41.000+00:00',
        'toItems': [
            {
                'id': 90,
                'part': {
                    'id': 28,
                    'name': 'B201',
                    'description': 'Premium Brake Cables'
                },
                'type': {
                    'id': 10,
                    'name': 'Send'
                },
                'status': 'Closed Short',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'lineNumber': 1,
                'note': 'Handle with care',
                'quantity': '10',
                'quantityFulfilled': '3',
                'quantityPicked': '3',
                'unitCost': '25.50',
                'dateScheduled': '2026-05-15T21:17:24.000+00:00',
                'dateLastFulfilled': '2026-06-26T14:12:41.000+00:00'
            }
        ],
        'customFields': [
            {
                'id': 22,
                'name': 'Department',
                'value': 'Logistics',
                'type': 'Text'
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'close-short-transfer-order',
    title: 'Close short a transfer order',
    description: 'Completes a transfer order that was only partially fulfilled. ' +
        'The transfer order must be in Picking, Partial, Picked, or Shipped status. ' +
        'Close short voids any unfulfilled line items, marks partially fulfilled line items as Closed Short, ' +
        'and sets the transfer order status to Closed Short. ' +
        'All line items must be received first: a transfer order with items still in transit ' +
        '(shipped but not yet received) cannot be closed short, and a partially fulfilled item must have ' +
        'its picked quantity fully received — this preserves the open receipt for the in-transit inventory. ' +
        'Any entered or packed shipments and committed pick items must be voided first, ' +
        'and no line items may be in Picking or Picked status. ' +
        'Returns 404 if the transfer order is not found.',
    endpoint: {
        verb: 'POST',
        path: '/transfer-orders/:id/close-short',
        tooltip: 'Close short a transfer order',
    },
    attributes: [],
    requestObject: closeShortTransferOrderRequest,
    responseObject: closeShortTransferOrderResponse,
};

export default data;
